import { render, staticRenderFns } from "./promotionNUDG.vue?vue&type=template&id=0b2f295a"
import script from "./promotionNUDG.vue?vue&type=script&lang=js"
export * from "./promotionNUDG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports